// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../../vendor/runtime.js";
const ResetInput = ({
  type: a,
  name: n,
  placeholder: i,
  value: l,
  onChange: c,
  error: u,
  className: m = "",
  icon: f = null,
  maxLength: x,
}) => {
  const [p, g] = React.useState(false),
    b = l && l.length > 0,
    y = p || b;
  return (
    <div className={"relative mb-4"}>
      <div
        className={`relative bg-gray-50 rounded-xl transition-all duration-300 ${p ? "bg-white shadow-lg ring-2 ring-indigo-500 ring-opacity-50" : "hover:bg-gray-100"} ${u ? "ring-2 ring-red-500 ring-opacity-50" : ""}`}
      >
        {f && (
          <div
            className={
              "absolute left-3 lg:left-4 top-1/2 transform -translate-y-1/2 text-gray-400 transition-colors duration-300"
            }
          >
            <div className={"w-4 h-4 lg:w-5 lg:h-5"}>{f}</div>
          </div>
        )}
        <input
          type={a}
          name={n}
          value={l}
          onChange={c}
          onFocus={() => g(true)}
          onBlur={() => g(false)}
          maxLength={x}
          className={`w-full px-3 py-3 lg:px-4 lg:py-4 ${f ? "pl-10 lg:pl-12" : ""} bg-transparent border-none rounded-xl text-gray-800 placeholder-transparent focus:outline-none transition-all duration-300 text-sm lg:text-base ${m}`}
          placeholder={i}
        />
        <label
          className={`absolute transition-all duration-300 pointer-events-none ${y ? `bg-white px-2 top-0 transform -translate-y-1/2 text-xs font-medium ${f ? "left-10 lg:left-12" : "left-3 lg:left-4"} ${p ? "text-indigo-600" : "text-gray-600"} ${u ? "text-red-500" : ""}` : `top-1/2 transform -translate-y-1/2 text-gray-500 text-sm lg:text-base ${f ? "left-10 lg:left-12" : "left-3 lg:left-4"}`}`}
        >
          {i}
        </label>
      </div>
      {u && (
        <div className={"mt-1 text-red-500 text-xs flex items-center animate-slideInLeft"}>
          <svg className={"w-3 h-3 mr-1 flex-shrink-0"} fill={"currentColor"} viewBox={"0 0 20 20"}>
            <path
              fillRule={"evenodd"}
              d={
                "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              }
              clipRule={"evenodd"}
            />
          </svg>
          {u}
        </div>
      )}
    </div>
  );
};
export { ResetInput };
